module.exports = require('./helpers/bundle-url').getBundleURL('h9q3T') + "Icon Blue 192.c7bd1d27.png";